/*
 * @Author: YuanYuan
 * @Date: 2024-06-25 17:30:30
 * @LastEditTime: 2026-03-26 15:01:32
 * @Description: 订单管理常量定义
 */
import i18n from '@/i18n'

export default [
  {
    name: 'ChargeMethodOptions',
    value: [
      { label: i18n.t('orders.fourthPeak'), value: 1 }, // 第四峰值
      { label: i18n.t('orders.95Value'), value: 2 }, // 95值
      { label: i18n.t('orders.firstPeak'), value: 3 }, // 第一峰值
      { label: i18n.t('orders.peakAverage'), value: 4 } // 峰值平均
    ]
  },
  {
    name: 'RefundStatusOptions',
    value: [
      { label: i18n.t('orders.refundRevewing'), value: 1, colorClazz: 'text-color-gold' }, // 退订审核中
      { label: i18n.t('orders.refundApproval'), value: 2, colorClazz: 'text-color-success' }, // 退订审核通过
      { label: i18n.t('orders.refundFailed'), value: 3, colorClazz: 'text-color-error' } // 退订审核不通过
    ]
  },
  // 对应csec2.0中 COMMON.parseOrderStatus() 返回值
  {
    name: 'OrderStatusOptions',
    value: [
      { label: i18n.t('orders.toBePaid'), value: 1, colorClazz: 'text-color-gold', icon: 'ws-icon-info-circle' }, // 待支付
      { label: i18n.t('orders.completed'), value: 2, colorClazz: 'text-color-success', icon: 'ws-icon-check-circle' }, // 已完成
      { label: i18n.t('orders.closed'), value: 3, colorClazz: 'text-color-info', icon: 'ws-icon-forbid' }, // 已关闭
      { label: i18n.t('orders.unsubscribing'), value: 4, colorClazz: 'text-color-gold', icon: 'ws-icon-time' }, // 退订中
      { label: i18n.t('orders.unsubSucceed'), value: 5, colorClazz: 'text-color-success', icon: 'ws-icon-check-circle' }, // 退订成功
      { label: i18n.t('orders.unsubFailed'), value: 6, colorClazz: 'text-color-error', icon: 'ws-icon-warning-circle' }, // 退订失败
      { label: i18n.t('orders.pendingReview'), value: 7, colorClazz: 'text-color-gold', icon: 'ws-icon-edit-outline' }, // 待审核
      { label: i18n.t('orders.outDate'), value: 8, colorClazz: 'text-color-info', icon: 'ws-icon-forbid' }, // 已作废
      { label: i18n.t('orders.payConfirming'), value: 19, colorClazz: 'text-color-orange', icon: 'ws-icon-load-dot' }, // 支付确认中
      { label: i18n.t('orders.paySucceed'), value: 20, colorClazz: 'text-color-success', icon: 'ws-icon-check-circle' } // 支付成功
    ]
  },
  // 对应csec2.0中 COMMON.parseOrderType() 返回值
  {
    name: 'OrderTypeOptions',
    value: [
      { label: i18n.t('orders.newPurchase'), value: 0 }, // 新购
      { label: i18n.t('orders.newPurchase'), value: 1 }, // 新购
      { label: i18n.t('orders.renewal'), value: 2 }, // 续费
      { label: i18n.t('orders.upgrade'), value: 3 }, // 升级
      { label: i18n.t('orders.dailySettle'), value: 4 }, // 每日结算
      { label: i18n.t('orders.recharge'), value: 5 }, // 充值
      { label: i18n.t('orders.turnIn'), value: 6 }, // 转入
      { label: i18n.t('orders.turnOut'), value: 7 }, // 转出
      { label: i18n.t('orders.unsubscribe'), value: 8 }, // 退订
      { label: i18n.t('orders.withdrawal'), value: 9 } // 提现
    ]
  },
  // 对应csec2.0中 COMMON.parsePayType() 返回值
  {
    name: 'PayTypeOptions',
    value: [
      { label: i18n.t('common.alipay'), value: 1 }, // 支付宝
      { label: i18n.t('common.unionpay'), value: 2 }, // 银联
      { label: i18n.t('orders.cashAccount'), value: 3 }, // 现金账户
      { label: i18n.t('orders.offlinePay'), value: 5 }, // 线下支付
      { label: i18n.t('orders.selfPay'), value: 6 }, // 自付
      { label: 'Stripe', value: 8 },
      { label: 'PayPal', value: 7 },
      { label: 'Triple-A', value: 9 },
      { label: i18n.t('orders.substitutePay'), value: 4 } // 代付
    ]
  },
  // 订单详情商品表格
  {
    name: 'DetailGoodsTableConfig',
    value: () => {
      return {
        border: true,
        class: 'mb-16'
      }
    }
  },
  // 对应csec2.0中的 COMMON.parseChargeType() 返回值
  {
    name: 'ChargeModeOptions',
    value: [
      { label: i18n.t('orders.prepaid'), value: 1 }, // 预付费
      { label: i18n.t('orders.postpay'), value: 2 } // 后付费
    ]
  }
]
